<div class="airo-chat-dialog">
  <app-modal-header-common [title]="'Airo Data'" [dialogRef]="dialogRef">
  </app-modal-header-common>
  <div id="chat">
    <div class="chat__conversation-board" id="conversationBoard" appTextSelect>
      <div
        class="chat__conversation-board__message-container"
        style="background: #013770; color: white"
      >
        <div class="chat__conversation-board__message__person">
          <div class="chat__conversation-board__message__person__avatar">
            <span
              ><img src="assets/images/icons8-user-64.png" alt="User"
            /></span>
          </div>
        </div>
        <div class="chat__conversation-board__message__context">
          <div class="chat__conversation-board__message__bubble">
            <span style="font-weight: 700">{{ userQuery }}</span>
          </div>
        </div>
      </div>

      <div class="chat__conversation-board__message-container">
        <div class="chat__conversation-board__message__person">
          <div class="chat__conversation-board__message__person__avatar">
            <span><img src="assets/images/icons8-ai-96.png" alt="AI" /></span>
          </div>
        </div>
        <div class="chat__conversation-board__message__context">
          <div class="chat__conversation-board__message__bubble">
            <div class="markdown-container">
              <div class="loader" *ngIf="isLoading"></div>
              <div *ngIf="!isLoading && response">
                <div class="custom-table mb-3">
                  <table class="table table-bordered" #queryResultTable>
                    <thead>
                      <tr>
                        <th *ngFor="let col of tableColumns">
                          {{ col }}
                          <span
                            *ngIf="response.columns_metadata[col]?.unit"
                            style="color: white"
                            >({{ response.columns_metadata[col]?.unit }})</span
                          >
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of queryResults">
                        <td *ngFor="let col of tableColumns">
                          {{
                            response?.columns_metadata[col]?.type === "datetime"
                              ? (item[col] | date: "MMMM dd yyyy")
                              : response?.columns_metadata[col]?.type ===
                                  "month"
                                ? (item[col] | date: "MMMM yyyy")
                                : ["int", "float"].includes(
                                      response?.columns_metadata[col].type
                                    )
                                  ? (item[col] | number: "1.0-2")
                                  : item[col]
                                    ? item[col]
                                    : ["int", "float"].includes(
                                          response?.columns_metadata[col].type
                                        )
                                      ? (item[col] | number: "1.0-2")
                                      : item[col]
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-between">
                  <mat-paginator
                    [length]="recordsCount"
                    [pageSizeOptions]="[10, 20, 50, 100, recordsCount].sort()"
                    [pageSize]="pageSize"
                    [pageIndex]="page - 1"
                    (page)="handlePageChange($event)"
                    aria-label="Select page"
                  >
                  </mat-paginator>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
